const MIDA_READY_TIMEOUT_MS = 2000
const MIDA_POLL_INTERVAL_MS = 50

const waitForMida = (timeoutMs = MIDA_READY_TIMEOUT_MS): Promise<boolean> =>
  new Promise(resolve => {
    if (window.mida?.isLoaded) {
      resolve(true)
      return
    }
    const start = Date.now()
    const intervalId = window.setInterval(() => {
      if (window.mida?.isLoaded) {
        window.clearInterval(intervalId)
        resolve(true)
      } else if (Date.now() - start >= timeoutMs) {
        window.clearInterval(intervalId)
        resolve(false)
      }
    }, MIDA_POLL_INTERVAL_MS)
  })

export const trackMidaABTestEvent = async (event: string) => {
  try {
    if (window.mida?.isLoaded) {
      await window.mida.track(event)
      return
    }

    // Wait for the SDK to finish loading rather than silently queuing into window.mdq,
    // which is lost if the page navigates before Mida flushes it.
    if (await waitForMida()) {
      await window.mida.track(event)
      return
    }
  } catch {
    // mida.track threw/rejected; fall through to the queue so the event isn't lost.
  }

  // Last resort: queue and hope the SDK loads before navigation.
  window.mdq = Array.isArray(window.mdq) ? window.mdq : []
  window.mdq.push(["track", event])
}
